<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">Fees</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>

    <div class="container-center lg">
      <div class="panel panel-filled">
        <div class="panel-body">
          <h4 class="text-grad">Trading Fees</h4>
          <p>
            Fees are automatically deducted at the time the trade is executed.
            There are no fees charged at the time of created an order, and if
            you cancel the order no trade fees are charged at all.
          </p>
          <table class="table table-condensed">
            <thead>
              <tr>
                <th>Level</th>
                <th>Maker / Taker</th>
                <th>365 cost</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>USER</td>
                <td>0.10% / 0.25%</td>
                <td>0</td>
              </tr>
              <tr>
                <td>PRO</td>
                <td>0.10% / 0.15%</td>
                <td>1,000,000</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="panel-body">
          <h4 class="text-grad">Withdrawal Fees</h4>
          <table class="table table-condensed">
            <thead>
              <tr>
                <th>Currency</th>
                <th>Symbol</th>
                <th>Withdrawal Fee</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="c in getCurrency" v-bind:key="c._id">
                <td>{{ c.name }}</td>
                <td>{{ c.coin }}</td>
                <td>
                  <span class="c-white font-bold">{{
                    c.withdraw_fee / 1
                  }}</span>
                  {{ c.coin }}
                </td>
              </tr>
            </tbody>
          </table>
          <p class="c-white">
            Fees are subject to change at any time without prior notice, please
            check our fee schedule regularly and before each withdrawal or
            deposit so that you are familiar with the amount you will be
            charged.
          </p>
        </div>
        <div class="panel-body">
          <h4 class="text-grad">Deposit Fees</h4>
          <p>
            Most deposits are free, however we charge fees on some currencies
            for very small deposit amounts. If you deposit more than the minimum
            deposit amount then you will not be charged any fee.
          </p>
          <p>
            Deposits on all other currencies not listed above are free. Note
            that if you deposit less than the fee amount your entire deposit
            will be used to pay the fee.
          </p>
        </div>
        <div class="panel-body">
          <h4 class="text-grad">Max Withdrawals per Day</h4>
          <p>Max Withdraw Count and Max Withdraw Amount are unlimited.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["getCurrency"])
};
</script>
